import apiClient from "./apiClient";
import { PageResponse } from "@/types/pageResponse";
import {SearchParam} from "@/types/searchParam";
import {
    ChildFactPaymentResponse,
    ChildProfileInfoResponse,
    ChildrenShortInfoResponse, ChildTimesheetInfoResponse,
    ChildUsedKindergartenResponse
} from "@/types/childrenResponse";
const BASE_URL = process.env.VUE_APP_BASE_URL as string;
const BASE_URL_CHILDREN = `${BASE_URL}/api/v1/children`;

export async function findChildrenByFilter(params: SearchParam): Promise<PageResponse<ChildrenShortInfoResponse>> {
    try {
        const response = await apiClient.post<PageResponse<ChildrenShortInfoResponse>>(
            `${BASE_URL_CHILDREN}/list`,
            params
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching data list:", error);
        throw error;
    }
}

export async function getChildProfileById(id: string): Promise<ChildProfileInfoResponse> {
    try {
        const response = await apiClient.get<ChildProfileInfoResponse>(
            `${BASE_URL_CHILDREN}/${id}`,
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching data list:", error);
        throw error;
    }
}

export async function getChildrenKindergartens(id: string): Promise<ChildUsedKindergartenResponse[]> {
    try {
        const response = await apiClient.get<ChildUsedKindergartenResponse[]>(
            `${BASE_URL_CHILDREN}/${id}/used/kindergarten`,
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching data list:", error);
        throw error;
    }
}

export async function getChildrenFactPayments(id: string): Promise<ChildFactPaymentResponse[]> {
    try {
        const response = await apiClient.get<ChildFactPaymentResponse[]>(
            `${BASE_URL_CHILDREN}/${id}/payed/info/list`,
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching data list:", error);
        throw error;
    }
}

export async function getChildrenTimesheet(id: string): Promise<ChildTimesheetInfoResponse[]> {
    try {
        const response = await apiClient.get<ChildTimesheetInfoResponse[]>(
            `${BASE_URL_CHILDREN}/${id}/timesheet/list`,
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching data list:", error);
        throw error;
    }
}